/* Lenis easing for fine pointers only (touch keeps its own inertia), never for reduced motion, and
 * nothing is fetched otherwise. Returns the teardown. */
export function armSmoothScroll(): () => void {
  const wanted =
    window.matchMedia("(pointer: fine)").matches &&
    !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!wanted) return () => {};

  let lenis: { destroy(): void } | null = null;
  let gone = false;
  const start = async () => {
    const [{ default: Lenis }] = await Promise.all([
      import("lenis"),
      import("lenis/dist/lenis.css"),
    ]);
    if (gone) return;
    lenis = new Lenis({
      autoRaf: true,
      lerp: 0.1,
      /* in-page links glide too, stopping clear of the sticky header */
      anchors: { offset: -72 },
      allowNestedScroll: true,
      stopInertiaOnNavigate: true,
      /* menus, dialogs and the film keep their own native scroll */
      prevent: (node) =>
        node.closest('[role="dialog"], [role="menu"], [data-radix-popper-content-wrapper]') !==
        null,
    });
  };
  /* without it the page simply scrolls natively */
  start().catch(() => {});
  return () => {
    gone = true;
    lenis?.destroy();
    lenis = null;
  };
}
